module.exports = {
    extends: [
        '/',
        'templates',
        'core',
        'form',
        'propertiesForm',
    ],

    config: {
        entityContext: 'costCenters',
        preventClearOnCancel: true,
    },

    model: {
        globalStaticFields: {
            type: 'customFlat',
        }
    },
}